import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    ManufacturerProductId: z.any().refine((val) => {
        // Accept object from Autocomplete or non-empty string
        if (typeof val === "string") return val.length > 0;
        if (val && typeof val === "object" && "value" in val) return true;
        return false;
    }, "Product is required"),
    SupplierUnitType: z.string().optional(),
    SupplierUnitSize: z.coerce.number().positive().optional().nullable(),
    UnitPrice: z.coerce.number().nonnegative("Unit Price must be a non-negative number"),
    UnitsAvailable: z.coerce.number().int().nonnegative("Units Available must be a non-negative integer"),
    MinOrderQuantity: z.coerce.number().int().positive().default(1),
    OrderStep: z.coerce.number().int().positive().optional().nullable(),
});

const supplierInventoryResolver = zodResolver(schema);

export default supplierInventoryResolver;
